import { useGetChartChanceHistoryQuery } from "~/feature/chart/chartApi";
import type { IChartSelection } from "~/feature/chart/types";
import { buildChartRequest } from "~/feature/chart/utils";
import { useBackgroundError } from "~/hooks/useBackgroundError";

export const useChartChanceHistory = (selection: IChartSelection) => {
  const { params, options } = buildChartRequest(selection);
  const { data, currentData, isUninitialized, isLoading, isFetching, error } =
    useGetChartChanceHistoryQuery(params, options);

  useBackgroundError(error);

  const isPending = isUninitialized || isLoading || isFetching;
  const isChanceHistoryUnavailable = !!error && !currentData;

  return {
    chanceHistory: isChanceHistoryUnavailable ? [] : (data ?? []),
    isChanceHistoryLoading: isPending && !data,
    isChanceHistoryFetching: isPending,
    isChanceHistoryUnavailable,
  };
};
